$(document).ready(function(){
    $('.tab_item').click(function(){
        $('.tab_item').removeClass('active').addClass('pause');
      $(this).addClass('active').removeClass('pause');
    });

    $('.fa-arrow-circle-right').click(function(){
      $(this).parent('tab_item').removeClass('active').addClass('pause');
      var active = $(this).parent('tab_item').data("id");
      console.log (active);
      newTab = active + 1;
      
      
     // $(newTab).addClass('active').removeClass('pause');
    });
});

$(document).ready(function(){
  $(".announcement-slider").slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 1000,
    vertical: true,
    adaptiveHeight: false,
    pauseOnHover: false,
    autoplaySpeed: 4000,
    responsive: [{
        breakpoint: 768,
        settings: {
            adaptiveHeight: true
        }
    }]
  });
});
  
  $(document).ready(function(){
    var activeClass = 'slick-active',
    ariaAttribute = 'aria-hidden';
  
    $('.vert-slider').on('init', function () {
  
    $('.vert-slider .slick-dots li:first-of-type').addClass(activeClass).attr(ariaAttribute, false);
    }).on('afterChange', function (event, slick, currentSlide) {
    var $dots = $('.vert-slider .slick-dots');
  
    $dots.each(function () {
        $('li', $(this)).eq(currentSlide).addClass(activeClass).attr(ariaAttribute, false);
    });
    });
    $(".vert-slider").slick({
      dots: true,
      
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      speed: 2000,
      fade: true,
      adaptiveHeight: false,
      pauseOnHover: false,
      autoplaySpeed: 4000,
      responsive: [{
          breakpoint: 768,
          settings: {
              adaptiveHeight: true
          }
      }]
    });
  });